module.exports = __webpack_public_path__ + "static/media/gasstove.8cb44430.svg";